import { axios } from "../../util/axiosConfig";
import { incidents } from "../urls";

const getSingleIncident = ({ id }) =>
  axios.get(incidents.single + `/${id}`).then(response => response.data);

export default getSingleIncident;
